import React, { useState } from "react";
import Switch from "@mui/material/Switch";

import EmojiWarningPopup from "./EmojiWarningPopup";
import EmojiEditPopup from "./EmojiEditPopup";
import { usePermission } from "Context/PermissionContext";

const CategorySection = ({
  category,
  group,
  onCategoryToggle,
  onAddEmoji,
  fetchAllEmojis,
  categories,
  staffId,
}) => {
  const [warnPopupOpen, setWarnPopupOpen] = useState(false);
  const [editEmojiModalOpen, setEditEmojiModalOpen] = useState(false);
  const [emojiDetails, setEmojiDetails] = useState({});

  const { permissions } = usePermission();
  const currentTabPermissions =
    permissions?.coinManagement?.subModule?.manageGifts?.permissions;

  const gifts = group?.gifts || [];

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-shadow hover:shadow-md">
      {/* ── Category header row ── */}
      <div className="flex items-center justify-between px-5 py-4">
        {/* Left: name + emoji count badge */}
        <div className="flex flex-1 items-center gap-3">
          <span className="text-base font-semibold text-gray-800">
            {category.name}
          </span>
          <span className="rounded-full bg-pink-50 px-2 py-0.5 text-xs font-semibold text-[#c51369]">
            {gifts.length} emoji{gifts.length !== 1 ? "s" : ""}
          </span>
        </div>

        {/* Right: active toggle only */}
        <Switch
          checked={category.isActive ?? true}
          onChange={() => onCategoryToggle(category)}
          size="small"
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: "#c51369" },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
              backgroundColor: "#c51369",
            },
          }}
        />
      </div>

      {/* ── Modals (kept so edit/delete triggered elsewhere still work) ── */}
      <EmojiWarningPopup
        fetchAllEmojis={fetchAllEmojis}
        emojiDetails={emojiDetails}
        warnPopupOpen={warnPopupOpen}
        handleClose={() => setWarnPopupOpen(false)}
        staffId={staffId}
      />
      <EmojiEditPopup
        fetchAllEmojis={fetchAllEmojis}
        emojiDetails={emojiDetails}
        editEmojiModalOpen={editEmojiModalOpen}
        handleEmojiModalClose={() => setEditEmojiModalOpen(false)}
        staffId={staffId}
        categories={categories}
      />
    </div>
  );
};

export default CategorySection;
